import { noop } from "lodash";
import { createContext, useContext } from "react";

const AgentProfileContext = createContext<{
  agent: any;
  isLoading: boolean;
  isFullPageView?: boolean;
  onClose?: () => void;
}>({
  agent: null,
  isLoading: true,
  isFullPageView: false,
  onClose: () => {},
});

AgentProfileContext.displayName = "AgentProfileContext";

export const useCommunityAiAgentProfileContext = () =>
  useContext(AgentProfileContext);

export const AgentProfileContextProvider = ({
  agent,
  isFullPageView = false,
  isLoading,
  children,
  onClose = noop,
}: {
  agent: any;
  isLoading: boolean;
  children: any;
  isFullPageView?: boolean;
  onClose?: () => void;
}) => (
  <AgentProfileContext.Provider
    value={{ agent, isLoading, isFullPageView, onClose }}
  >
    {children}
  </AgentProfileContext.Provider>
);
